import { createEvent, createStore } from 'effector'
import { compact, flattenDeep } from 'lodash'

import type { SentMediaMessage } from '@/modules/chatting/types.ts'

export const resetSentMedia = createEvent('reset sent media')
export const addSentMedia = createEvent<SentMediaMessage[]>('add sent media')
export const $sentMedia = createStore<SentMediaMessage[]>([], {
  name: 'sent media',
})
  .on(addSentMedia, (store, data) => {
    return [...store, ...data]
  })
  .reset(resetSentMedia)

export const $allMediaFromCache = $sentMedia.map((media) =>
  compact(
    flattenDeep(
      media.map(
        ({ media, isOpened, isFree }) =>
          media?.map((m) => ({ ...m, isOpened, isFree })) ?? [],
      ),
    ),
  ),
)

export const setPostedMedia = createEvent<number[]>('set posted media')
export const $postedMedia = createStore<number[]>([], {
  name: 'posted media',
}).on(setPostedMedia, (_, data) => data ?? [])

export const setFinishedPullingSentMedia = createEvent<boolean>(
  'set finished pulling sent media',
)
export const $finishedPullingSentMedia = createStore(false, {
  name: 'is finished pulling sent media',
}).on(setFinishedPullingSentMedia, (_, data) => data)

export const setMediaErrorMessage = createEvent<Nullable<string>>(
  'set media error message',
)
export const $mediaErrorMessage = createStore<Nullable<string>>(null, {
  name: 'media error message',
}).on(setMediaErrorMessage, (_, data) => data)
